import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PrependBasePathPipe } from '@pipes/prepend-base-path.pipe';
import { BgImageDirective } from '@directives/bg-image.directive';

@Component({
  selector: 'cck-login-banner',
  standalone: true,
  imports: [CommonModule, PrependBasePathPipe, BgImageDirective],
  templateUrl: './login-banner.component.html',
  styleUrls: ['./login-banner.component.scss'],
})
export class LoginBannerComponent {}
